export const CREATE_GIFT_CARD_REQUEST = '[giftCards] Create gift card request' as const;
export const UPDATE_GIFT_CARD_REQUEST = '[giftCards] Update gift card request' as const;
export const REMOVE_GIFT_CARD_REQUEST = '[giftCards] Remove gift card request' as const;
export const GET_GIFT_CARDS_REQUEST = '[giftCards] Get gift cards request' as const;
export const SET_GIFT_CARDS = '[giftCards] Set gift cards' as const;
export const REMOVE_GIFT_CARD = '[giftCards] Remove gift card' as const;
export const UPDATE_GIFT_CARD = '[giftCards] Update gift card' as const;
export const CREATE_GIFT_CARD = '[giftCards] Create gift card' as const;
export const SET_IS_CARDS_LOADING = '[giftCards] Set is loading' as const;
